import React from 'react';

export default function PlusRoundIcon() {
	return (
		<svg
			width='16'
			height='16'
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M12 7.8125V8.1875C12 8.40625 11.8125 8.5625 11.625 8.5625H8.5625V11.625C8.5625 11.8438 8.375 12 8.1875 12H7.8125C7.59375 12 7.4375 11.8438 7.4375 11.625V8.5625H4.375C4.15625 8.5625 4 8.40625 4 8.1875V7.8125C4 7.625 4.15625 7.4375 4.375 7.4375H7.4375V4.375C7.4375 4.1875 7.59375 4 7.8125 4H8.1875C8.375 4 8.5625 4.1875 8.5625 4.375V7.4375H11.625C11.8125 7.4375 12 7.625 12 7.8125ZM15.75 8C15.75 12.2812 12.2812 15.75 8 15.75C3.71875 15.75 0.25 12.2812 0.25 8C0.25 3.71875 3.71875 0.25 8 0.25C12.2812 0.25 15.75 3.71875 15.75 8ZM14.75 8C14.75 4.28125 11.6875 1.25 8 1.25C4.25 1.25 1.25 4.3125 1.25 8C1.25 11.75 4.28125 14.75 8 14.75C11.7188 14.75 14.75 11.7188 14.75 8Z'
				fill='white'
			/>
		</svg>
	);
}
